import React, { useEffect, useRef } from "react";
// import { motion } from "framer-motion";
import hero from "../media/hero.webp";
import virginia from "../media/Virginia.webp";

// import FallsChurch from "../media/Falls-Church.webp";
import Lenis from "lenis";
import HorizontalCarrusel from "../components/HorizontalCarrusel";
import { Link } from "react-router";
import ProvenApproach from "../components/ProvenApproach";
import SEO from "../seo/Seo";
import InnovativeApproach from "../components/InnovativeAproach";
import useWindowSize from "../hooks/useWindowSize";
import MapIld from "../components/MapIld";

const Home = () => {
  const scrollWrapper = useRef(null);
  const scrollContent = useRef(null);
  // const targetRef = useRef(null);
  const width = useWindowSize();
  // console.log(width);

  const cards = [
    {
      num: "01",
      txt: "Lengthy turnaround times for engineering plan approvals.",
    },
    {
      num: "02",
      txt: "Rising construction costs that strain budgets and threaten project viability.",
    },
    {
      num: "03",
      txt: "Affordability crisis in Northern Virginia and across the U.S.",
    },
    {
      num: "04",
      txt: "Delays causing compounding risks: loan extensions, contractor repricing, reduced investor confidence, higher material costs, and delayed revenue.",
    },
  ];

  // const y = useTransform(scrollYProgress, [0, 1], ["60%", ["-27%"]]);

  useEffect(() => {
    const lenis = new Lenis({
      wrapper: scrollWrapper.current || undefined,
      content: scrollContent.current || undefined,
      orientation: "horizontal",
      gestureOrientation: "horizontal",
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => {
      lenis.destroy();
    };
  }, []);
  return (
    <>
      <SEO
        title="Building the Future"
        description="We help developers, investors, and homeowners move with confidence, building places that grow in value, enrich daily life, and stand as legacies future generations can trust."
        image="/src/media/proven_approach.web"
        keywords="land development, Northern Virginia, United States, Precision Civil Engineering & Surveying, engineering, project management, permitting,  "
        url="https://www.innovativeld.com/"
      />
      <section className="relative w-full h-screen text-primario bg-primario">
        {/* <img
          src={hero}
          alt="Creditos al autor: https://unsplash.com/es/fotos/fotografia-de-angulo-bajo-de-un-edificio-688Fna1pwOQ?utm_content=creditShareLink&utm_medium=referral&utm_source=unsplash"
          className="object-cover w-full h-full object-right"
          /> */}
        <img
          src={hero}
          width={1920}
          alt="Innovative Land Developers. A disciplined approach to Northern Virginia land development—built
            for developers, investors, and future homeowners. "
          className="absolute inset-0 w-full h-full object-cover opacity-100"
        />
        <div className="absolute inset-0 p-6 lg:p-10 font-secundaria flex flex-col justify-between w-full">
          <p className="max-w-2xl py-10 text-base lg:text-2xl  text-secundario self-start lg:self-end">
            Where disciplined analysis meets land development—turning risk into
            resilience and vision into lasting communities. We help developers,
            investors, and homeowners move with confidence, building places that
            grow in value, enrich daily life, and stand as legacies future
            generations can trust.
          </p>
          
          <h1 className="w-full text-5xl sm:text-6xl md:text-7xl lg:text-8xl 2xl:text-9xl text-secundario font-bold font-primaria">
            Innovative Land Developers
          </h1>
        </div>
      </section>
      <section className="w-full bg-secundario font-secundaria grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 xl:grid-rows-6 lg:grid-rows-5 xl:grid-cols-6 p-6 md:p-10 gap-5">
        <h2 className="text-4xl sm:text-5xl md:text-7xl lg:text-7xl 2xl:text-8xl font-primaria font-bold col-span-1 md:col-span-2 lg:col-span-3 lg:row-span-2 w-full place-self-start lg:place-self-end text-left lg:text-right">
          Building the Future
        </h2>

        <div className="col-span-1 md:col-span-2 lg:col-span-3 lg:row-span-2 lg:col-start-1 lg:row-start-3 flex flex-col gap-5 place-self-start lg:place-self-end text-left lg:text-right">
          <p className="text-base md:text-lg lg:text-xl max-w-full lg:max-w-3xl leading-relaxed">
            At Innovative Land Developers, we do more than design sites—we shape
            places that drive resilience, prosperity, and long-term value. Our
            disciplined engineering and surveying services form the foundation
            of responsible growth across the DMV and Virginia coast. From dense
            urban centers to expanding suburban communities, we give developers,
            builders, and homeowners the clarity and confidence to move forward.
          </p>
          <Link to={"/consultation"}>
            <button className="bg-primario text-secundario px-5 py-2 md:px-6 md:py-3 rounded-2xl text-base md:text-lg lg:text-xl font-bold self-start lg:self-end">
              Schedule a Consultation
            </button>
          </Link>
        </div>

        <div className="w-full col-span-1 md:col-span-2 md:row-start-3 lg:col-span-3 lg:row-span-4 lg:col-start-4 lg:row-start-1 overflow-hidden rounded-2xl lg:rounded-3xl lg:place-self-start">
          <img
            src="https://innovativeld.com/assets/Site-Grading-PLan.png"
            alt="Precision Civil Engineering & Surveying"
            className="object-cover w-full h-full md:h-full lg:h-[70vh] lg:w-full " 
          />
        </div>

        <h3 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl 2xl:text-8xl font-primaria font-bold col-span-1 md:col-span-2 lg:col-span-6 lg:row-span-2 lg:row-start-5 lg:text-right">
          Precision Civil Engineering & Surveying
        </h3>
      </section>
      <section className="bg-[#030712] flex flex-col lg:flex-row items-center">
        <div className="w-full lg:w-1/3 flex flex-col gap-4 items-center lg:items-end m-10 xl:m-20">
          <h2 className="text-secundario text-4xl sm:text-5xl md:text-7xl font-primaria font-bold text-left lg:text-right">
            Our Projects
          </h2>
          <Link to="/projects" className="text-primario bg-secundario p-4 rounded-lg font-primaria font-bold ">See projects</Link>
        </div>
        <div className="w-full lg:w-2/3">
          <MapIld />
        </div>
      </section>
      <InnovativeApproach />

      <section className="min-h-[70vh] w-full bg-primario text-secundario font-primaria">
        {/* <HorizontalSlider/> */}
        <HorizontalCarrusel
          title="The Challenge"
          outputStart={width >= 768 ? "50%" : "10%"}
          outputEnd={width >= 768 ? "-50%" : "-78%"}
        >
          {cards.map((item, i) => (
            <div
              key={i}
              className="w-[35vh] h-[35vh] md:w-[40vh] md:h-[40vh] lg:w-[45vh] lg:h-[45vh] bg-secundario flex flex-col justify-between p-5 text-primario"
            >
              <span className="text-primario text-4xl md:text-5xl lg:text-6xl font-bold">
                {item.num}
              </span>
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold">
                {item.txt}
              </p>
            </div>
          ))}
        </HorizontalCarrusel>
      </section>
      <ProvenApproach />
      <section className="w-full bg-primario text-secundario flex flex-col md:flex-row items-center justify-between min-h-screen">
        <div className="h-[50vh] md:h-auto w-full md:w-1/2 p-6 md:p-10 flex flex-col justify-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 leading-tight font-primaria text-left md:text-left">
            Ready to Move Your Project Forward?
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-secundario max-w-2xl mb-6">
            Partner with us to minimize delays, manage risks and deliver lasting
            value in land development.
          </p>
          <Link
            to="/consultation"
            className="inline-block bg-secundario text-primario font-semibold text-base sm:text-lg md:text-xl px-5 py-3 rounded-lg shadow focus:outline-none focus:ring-4 focus:ring-secundario/40 self-start"
          >
            Book a Free Consultation
          </Link>
        </div>
        <div className="h-[50vh] md:w-1/2 md:h-screen relative overflow-hidden">
          <img
            src={virginia}
            alt="Foto de Derrick Brooks en Unsplash"
            className="object-cover w-full h-full"
          />
        </div>
      </section>
    </>
  );
};

export default Home;
